import React from 'react'
import Modal from '@material-ui/core/Modal'
import './BaseModal.scss'

const BaseModal = ({ children, visible, size='small', title, titleImage, color, onClose }) => {

  const getWidth = () => {
    switch(size) {
      case 'big': return '608px'
      case 'medium': return '470px'
      default: return '400px'
    }
  }

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={visible}
      onClose={onClose}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div className='base-modal-container' style={{ width: getWidth() }}>
        {
          title && (
            <div className='base-modal-container-header' style={{ backgroundColor: color }}>
              {titleImage && <img src={titleImage} alt='titleImage'/>}
              <p>{title}</p>
            </div>
          )
        }
        {children}
      </div>
    </Modal>
  )

}

export default BaseModal
